var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.openModal()}}},[_c('b-tooltip',{attrs:{"label":_vm.tooltipMessage,"multilined":"","position":"is-bottom"}},[_c('img',{attrs:{"src":require("../assets/icons/ic_paces_survey.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }